<template>
  <div style="max-width: 800px" class="m-auto">
    <h1>Создаем «Летопись финансовой мудрости семей Пермского края»</h1>

    <div v-if="step === 1">
      <h3 style="font-weight: normal; padding-top: 10px">Прими участие!</h3>

      <div style="padding-top: 30px; padding-bottom: 30px">
        <p>Заполни данную форму – и ты получишь открытку с финансовой мудростью своей семьи и шанс принять участие в семейном финансовом квизе.</p>
        <p style="padding-top: 10px">Самые интересные высказывания войдут в <a href="http://family_festival.tilda.ws/" target="_blank">«Летописи финансовой мудрости семей Пермского края»</a>.</p>
      </div>
      <!-- <hr> -->
      <label for="feedback-address">Как с вами связаться:</label><input type="text" class="form-control" id="feedback-address" name="feedback-address" v-model="feedbackAddress" required>
      <p>Впишите свой адрес электронной почты или номер телефона, чтобы мы смогли связаться с вами.</p>
      <div class="form-check custom-control custom-checkbox" style="padding-bottom: 20px; padding-top: 10px;">
        <input class="form-check-input custom-control-input" type="checkbox" v-model="privateDataShareConfirmed">
        <label class="form-check-label custom-control-label" for="check-option10_2">Продолжая, я даю <a href="/certificates/legal.pdf" target="_blank">согласие на хранение и обработку персональных данных</a></label>
      </div>
      <button class="btn btn-success" type="submit" :disabled="!nextEnabled" @click="step++">Начать!</button>
    </div>

    <div v-else-if="step === 2">
      <h3 style="font-weight: normal; padding-top: 10px; padding-bottom: 20px">Шаг 1.</h3>
      <!-- <div style="padding-top: 30px">
        <p>Фамилия/фамилии твоей семьи. Фото.</p>
      </div> -->
      <div style="padding-bottom: 15px">
      <label for="family-name">Фамилия/фамилии твоей семьи:</label><input type="text" class="form-control" id="family-name" name="family-name" v-model="familyName" required>
      </div>
      <div style="padding-bottom: 15px">
      <label for="photo">Фото:</label><input type="file" class="form-control" ref="photo" id="photo" name="photo" accept="image/png, image/jpeg" @change="fileSelectedHandler">
      </div>

      <button class="btn btn-success" style="margin-top: 30px" type="submit" @click="step++" :disabled="!nextEnabled">Далее</button>
    </div>

    <div v-else-if="step === 3">
      <h3 style="font-weight: normal; padding-top: 10px">Шаг 2.</h3>
      <div style="padding-top: 30px">
        <p>Сформулируй финансовую мудрость своей семьи. Кратко.</p>
      </div>
      <input type="text" class="form-control" v-model="thing" required>
      <p v-if="thingIsOverflow" style="color: red">Постарайтесь уложиться в 50 символов.</p>
      <p>Обычно это та мысль, которая передается из поколения в поколения. Тот принцип, по которому живет ваша семья. Она может быть в виде фразы, пословицы, поговорки и т.п.</p>
      <button class="btn btn-success" style="margin-top: 30px" type="submit" @click="step++" :disabled="!nextEnabled || thingIsOverflow">Далее</button>
    </div>

    <div v-else-if="step === 4">
      <h3 style="font-weight: normal; padding-top: 10px">Шаг 3.</h3>
      <div style="padding-top: 30px">
        <p>Дай развернутое пояснение этой фразе. Почему правильно следовать этому принципу? К чему он приводит? Чего позволяет избежать?</p>
      </div>
      <input type="text" class="form-control" v-model="message" required>
      <p v-if="messageIsOverflow" style="color: red">Постарайтесь уложиться в 150 символов.</p>
      <p v-if="messageIsSmaller" style="color: red">Напишите минимум 85 символов.</p>
      <p>Вырази свое отношение. Поясни на своих примерах или примерах членов своей семьи. Не менее 85 и не более 150 знаков (с пробелами).</p>

      <button class="btn btn-success" style="margin-top: 30px" type="submit" @click="post" :disabled="!nextEnabled || messageIsOverflow || messageIsSmaller">Далее</button>
    </div>

    <div v-else-if="step === 5">
      <h3 style="font-weight: normal; padding-top: 10px">Шаг 4.</h3>
      <div style="padding-top: 30px">
        <p>Посмотри, как это получилось. Если необходимо, можешь вернуться к шагу 1 и что-то поправить.</p>
      </div>
      <div>
        <img :src="certificate" class="m-auto" style="max-width: 100%;">
      </div>

      <button class="btn btn-success" style="margin-top: 30px" type="submit" @click="step++">Готово</button>
      <button class="btn btn-secondary" style="margin-top: 30px; margin-left: 15px" type="submit" @click="step = 2">Заново</button>
    </div>

    <div v-else-if="step === 6">
      <h3 style="font-weight: normal; padding-top: 10px">Шаг 5.</h3>
      <div style="padding-top: 30px">
        <ol>
          <li>Сохрани себе готовую открытку.</li>
          <li v-if="!sent"><a href="#" @click="commit">Отправь</a> в банк «Летописи».</li>
          <li><a href="https://vk.com/app5898182_-215517789#s=2354995&force=1" target="_blank">Поделись</a> открыткой в сообщении сообщества ВКонтакте Финграм для того, чтобы стать участником розыгрыша и принять участие в квизе.</li>
        </ol>
      </div>
      <div>
        <img :src="certificate" class="m-auto" style="max-width: 100%;">
      </div>
      <!-- <button class="btn btn-success" style="margin-top: 30px" type="submit" @click="commit" :disabled="sent || loading">{{ sent ? "Отправлено для «Летописи»" : "Отправить" }}</button> -->
    </div>
  </div>
</template>
<script>

export default {
  name: 'App',
  data: function () {
    return {
      step: 1,
      privateDataShareConfirmed: false,
      familyName: "",
      familyDescription: "",
      photo: null,
      thing: "",
      message: "",
      certificateId: "",
      sent: false,
      loading: false,
      feedbackAddress: ""
    }
  },
  components: {
  },
  methods: {
    fileSelectedHandler: function () {
      this.photo = this.$refs.photo.files[0];
    },
    commit: function () {
      if (this.sent) {
        return;
      }
      this.loading = true;
      fetch('/certificates-api/certificate/'+this.certificateId, {
        method: 'POST',
        mode: 'no-cors'
      }).then(() => {
        this.sent = true;
      }).finally(() => {
        this.loading = false;
      })
    },
    post: async function () {
      const body = new FormData();
      body.append('family', this.familyName);
      body.append('thing', this.thing);
      body.append('message', this.message);
      body.append('photo', this.photo);
      body.append('feedback', this.feedbackAddress)

      this.loading = true;
      fetch('/certificates-api/certificate', {
        method: 'POST',
        body: body
      }).then(response => response.text())
          .then((body) => {
            this.certificateId = body;
            this.step++;
            this.loading = false;
          });
    }
  },
  computed: {
    thingIsOverflow: function () {
      return this.thing && this.thing.length > 50;
    },
    messageIsOverflow: function () {
      return this.message && this.message.length > 150;
    },
    messageIsSmaller: function () {
      return this.message && this.message.length < 85;
    },
    nextEnabled: function () {
      if (this.loading) {
        return false;
      }

      if (this.step === 1) {
        return this.privateDataShareConfirmed && !!this.feedbackAddress;
      } else if (this.step === 2) {
        return !!this.familyName && (this.photo !== null);
      } else if (this.step === 3) {
        return !!this.thing;
      } else if (this.step === 4) {
        return !!this.message;
      }

      return false;
    },
    certificate: function () {
      if (this.certificateId) {
        return "/certificates-api/certificate/" + this.certificateId;
      }
      return "";
    }
  }
}
</script>

<style>
p {
  padding: 0px;
  margin-bottom: 5px;
}
</style>
